var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92057 2.32C8.92057 1.59099 9.51156 1 10.2406 1C15.1007 1 19.0406 4.9399 19.0406 9.8C19.0406 10.529 18.4496 11.12 17.7206 11.12C16.9916 11.12 16.4006 10.529 16.4006 9.8C16.4006 6.39791 13.6427 3.64 10.2406 3.64C9.51156 3.64 8.92057 3.04902 8.92057 2.32Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0794 21.68C15.0794 22.409 14.4884 23 13.7594 23C8.89934 23 4.95943 19.0601 4.95943 14.2C4.95943 13.471 5.55041 12.88 6.27943 12.88C7.00844 12.88 7.59943 13.471 7.59943 14.2C7.59943 17.6021 10.3574 20.36 13.7594 20.36C14.4884 20.36 15.0794 20.951 15.0794 21.68Z",
    fill: "#111111"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.32 15.0801C1.59099 15.0801 1 14.4891 1 13.7601C1 8.89992 4.9399 4.96004 9.8 4.96004C10.529 4.96004 11.12 5.55103 11.12 6.28005C11.12 7.00906 10.529 7.60005 9.8 7.60005C6.39795 7.60005 3.64 10.358 3.64 13.7601C3.64 14.4891 3.04902 15.0801 2.32 15.0801Z",
    fill: "#111111"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.68 8.91995C22.409 8.91995 23 9.51094 23 10.24C23 15.1001 19.0601 19.04 14.2 19.04C13.471 19.04 12.88 18.449 12.88 17.72C12.88 16.9909 13.471 16.4 14.2 16.4C17.6021 16.4 20.36 13.6421 20.36 10.24C20.36 9.51094 20.951 8.91995 21.68 8.91995Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement);
export default __webpack_public_path__ + "static/media/element.b48d0b43a5319760c650b2e02b50e72a.svg";
export { ForwardRef as ReactComponent };